<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TA9krG/Images/9780316556057_cover_epub.jpg?1733067604822" alt="This image is the cover for the book For Those Who Know the Ending"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">For Those Who Know the Ending
      </h1>
      <p class="bookDescription body article font2">
        <p>Martin Sivok is in trouble. Tied to a chair, plastic strips biting his wrists, inside a deserted warehouse . . . There are only so many ways this scenario can end, most of them badly. For now his best hope is figuring out who put him here -- and staying conscious long enough to confront them. <br/><br/> To stay awake he reviews the past year of his life: evading the law in the Czech Republic by running to Glasgow, settling into a borderline respectable relationship with his landlady, and getting back into the life at the very bottom of the criminal ladder, alongside Usman Kassar, a cocky, goofy kid anxious to prove himself. <br/><br/> The job should be simple: Smash heads, grab cash, run. The trouble with being two outsiders is, you don't always know whose heads are too dangerous to crack, or whose cash is too hot to handle... <br/><br/> In sharp, precise prose, Malcolm Mackay -- an "elegant stylist" unmatched in contemporary noir (<i>Chicago Tribune</i>) -- captures the character of Glasgow and its underworld denizens.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Malcolm Mackay
      </h2>
      
      <p class="authorDescription body article"><B>Malcolm Mackay</B>'s Glasgow Trilogy has been nominated for several international prizes. <I>The Necessary Death of Lewis Winter</I> was shortlisted for the Edgar Awards' Best Paperback Original, the CWA John Creasey (New Blood) Dagger, and the Theakstons Old Peculier Crime Novel of the Year Award. <I>How a Gunman Says Goodbye</I> won the Deanston Scottish Crime Book of the Year Award. Mackay was born in Stornoway on Scotland's Isle of Lewis, where he still lives.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49ea04ef